import "./project.css";
import meter1 from "../../assets/meter1.svg";
import meter2 from "../../assets/meter2.svg";
import meter3 from "../../assets/meter3.svg";
import arrowLeft from "../../assets/arrow1.svg";
import arrowRight from "../../assets/arrow2.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import skill from "../../assets/skill.svg";

function Skill() {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };
  return (
    <div className="skill__container">
      <div className="tools__container">
        <div className="title__skills">
          <h2>Skills</h2>
          <div className="skill__short__text">
            <p>
              My skill set extends across various domains, allowing me to adapt
              and thrive in diverse environments. I approach challenges with a
              strategic mindset, combining technical expertise with a commitment
              to continuous learning. Below are some key areas where I excel and
              technologies I'm proficient in.
            </p>
          </div>
        </div>
        <div className="skills__image">
          <div className="carousel">
            <Carousel
              swipeable={true}
              draggable={true}
              showDots={false}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={4000}
              keyBoardControl={true}
              className="carousel__container"
              responsive={responsive}
            >
              <div className="skill1">
                <div>
                  <img src={meter1} alt="" />
                  <p>Javascript</p>
                </div>
              </div>
              <div className="skill1">
                <img src={meter2} alt="" />
                <p>Ruby</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>React Native</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>Node</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>Express</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>React Native</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>AWS</p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>NoSQL DB </p>
              </div>
              <div className="skill1">
                <img src={meter3} alt="" />
                <p>SQL DB</p>
              </div>
            </Carousel>

            {/* <div className="skill1">
            <img src="" alt="" />
            <p>Javascript</p>
          </div> */}
          </div>
        </div>
      </div>
      <div className="skill--image">
        <img src={skill} alt="" />
      </div>
    </div>
  );
}

export default Skill;

// redefining revival
